import React from "react";
import Layout from "./shared/Layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classes from "./assets/css/About.module.css"
import {
  faGithub,
  faTwitter,
  faLinkedin,
  faInstagram
} from "@fortawesome/free-brands-svg-icons";



const About = () => {
  return (
    <Layout>
      <div className={classes.about}>
        <div className={classes.about_container}>
          <div className={classes.image}>
            <img src="/images/me.jpg" alt="me" />
          </div>
          <div className={classes.content}>
            <h2 className="dark-text">Joshua Moses</h2>
            <p className={classes.title} style={{ color: "#142cff" }}>Web Developer</p>
            <p className={`${classes.text} dark-text mt-4`}>
              Hello! My name is Joshua and I enjoy creating things that lives on the internet. My love story with web development started back in 2020 when I changed my interest in machine learning and jump right into HTML and CSS. Turns out that decision would later go on to become one of the defining moment in my carrer.<br/> <br/> Fast-forward to today, and I have had the privillege of working as a freelancer for a <span style={{color: "#142cff"}}>school</span> and <span style={{color: "#142cff"}}>restaurant</span>, taking part in some of the best frontend courses and programmes namely Zuri Training, HNG Internship and Edconnect microdegree programme(now Betterchalk) and at the same time working alongside brilliant minds in the tech space. <br/><br/> Currently, I am working with a team of creatives as we are trying to build the next big solutions that will shape the world and how we do things. 
            </p>
            <div className={`${classes.socials} my-socials mt-5`}>
              <h6 className="social-header dark-text">Social Profile</h6>
              <div className="about-icons">
                <span className="me-3">
                  <a href="https://github.com/J0shcodes">
                    <FontAwesomeIcon icon={faGithub} />
                  </a>
                </span>
                <span className="me-3">
                  <a href="https://twitter.com/JPhleg">
                    <FontAwesomeIcon icon={faTwitter} />
                  </a>
                </span>
                <span className="me-3">
                  <a href="https://www.linkedin.com/in/joshua-moses-4117a7209/">
                    <FontAwesomeIcon icon={faLinkedin} />
                  </a>
                </span>
                <span className="me-3">
                  <a href="https://www.instagram.com/mjbond.007/">
                    <FontAwesomeIcon icon={faInstagram} />
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default About;
